export function briefToPlainText(brief) {
  const lines = [];
  lines.push(`COMPETITORPULSE — ${brief.target_company}${brief.user_product ? ` vs ${brief.user_product}` : ""}`);
  lines.push(`Generated ${new Date(brief.created_at).toLocaleString()}`);
  lines.push("");
  lines.push("COMPANY SNAPSHOT");
  lines.push(`- What they do: ${brief.snapshot.what_they_do}`);
  lines.push(`- Target customer: ${brief.snapshot.target_customer}`);
  lines.push(`- Business model: ${brief.snapshot.business_model}`);
  lines.push(`- Market position: ${brief.snapshot.market_position}`);
  lines.push("");
  lines.push("TOP 4 COMPETITORS");
  brief.competitors.forEach((c, i) => {
    lines.push(`${i + 1}. ${c.name}`);
    lines.push(`   Positioning: ${c.positioning}`);
    lines.push(`   Strength:    ${c.strength}`);
    lines.push(`   Weakness:    ${c.weakness}`);
  });
  lines.push("");
  lines.push("FEATURE GAP ANALYSIS");
  lines.push("Must-Have Parity:");
  brief.feature_gaps.must_have_parity.forEach((i) => lines.push(`  • ${i}`));
  lines.push("Competitor Lead:");
  brief.feature_gaps.competitor_lead.forEach((i) => lines.push(`  • ${i}`));
  lines.push("Differentiation Opportunity:");
  brief.feature_gaps.differentiation_opportunity.forEach((i) => lines.push(`  • ${i}`));
  lines.push("");
  lines.push("PRODUCT OPPORTUNITIES");
  brief.opportunities.forEach((o, i) => {
    lines.push(`${i + 1}. ${o.title}`);
    lines.push(`   ${o.rationale}`);
  });
  lines.push("");
  lines.push("PM NEXT STEPS");
  brief.next_steps.forEach((s) => lines.push(`- [${s.priority}] ${s.action}`));
  lines.push("");
  lines.push("AI-generated analysis — verify before use.");
  return lines.join("\n");
}
